module.exports = __webpack_public_path__ + "static/img/前策-2.d5a73ce8.png";